import { Typography, Card, CardContent, Grid } from '@material-ui/core';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { makeStyles } from '@material-ui/styles';
import { Formik, Form } from 'formik';
import React from 'react';
import LimitList from './LimitList';
import LimitListPharmacy from './LimitListPhamarcy';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    border: '1px solid rgba(0, 0, 0, .125)',
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0
    }
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary
  },
  color: {
    backgroundColor: '#f5f5f5'
  },
  newButton: {
    position: 'absolute',
    right: '10px'
  }
}));

export default function LimitSummary() {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <Card>
      <CardContent>
        <Formik
          initialValues={{
            documentType: ''
          }}
          onSubmit={() => {}}
        >
          {({ values, errors }) => (
            <Form>
              <div className={classes.root}>
                <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1bh-content"
                    id="panel1bh-header"
                    className={classes.color}
                  >
                    <Typography className={classes.heading}>Main Claims</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    {/* <Grid container spacing={2} direction="column"> */}
                    <LimitList />
                    {/* </Grid> */}
                  </AccordionDetails>
                </Accordion>
                <Accordion expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2bh-content"
                    id="panel2bh-header"
                    className={classes.color}
                  >
                    <Typography className={classes.heading}>Provident Usage</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <LimitListPharmacy />
                  </AccordionDetails>
                </Accordion>
              </div>
            </Form>
          )}
        </Formik>
      </CardContent>
    </Card>
  );
}
